module.exports = __webpack_public_path__ + "img/contact_join_01.a1840dee.png";